import { render, staticRenderFns } from "./SchedaValutazioneEsigenzeImmediateEditComponent.vue?vue&type=template&id=8b4607e6"
import script from "./SchedaValutazioneEsigenzeImmediateEditComponent.vue?vue&type=script&lang=js"
export * from "./SchedaValutazioneEsigenzeImmediateEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports